import { type SelectionsMachine } from '../../machine/selection-machine.ts';
import { type SelectionInput, type SelectionInputFactory } from '../types.ts';

/**
 * The InputManager is an abstraction around the lifecycle of SelectionInput instances.
 * It manages the simple setup and disposal of a set of SelectionInput instead of having
 * to do this on your own.
 */
export class InputManager {
  #inputs: SelectionInput[] = [];

  constructor(machine: SelectionsMachine, inputFactories: SelectionInputFactory[]) {
    this.#inputs = inputFactories.map((factory) => factory(machine));
  }

  setup() {
    for (const input of this.#inputs) {
      input.setup();
    }
  }

  dispose() {
    for (const input of this.#inputs) {
      input.dispose();
    }
  }
}
